export default __webpack_public_path__ + "static/media/winprize.b3bfd149.svg";